import { Information } from './Information';

const InformationBoxCE = () => {
  return (
    <Information.Root>
      <Information.Title />
      <Information.Body />
    </Information.Root>
  );
};

export { InformationBoxCE };
